import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, ConfigProvider, message, Spin } from "antd";
import { HomeOutlined, InfoCircleOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./termsConditions.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const TermsConditions = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchTerms = () => {
    callApi(
      "GET",
      routes.termsConditions,
      null,
      setLoading,
      (res) => {
        // Expecting something like { data: { content: "<p>...</p>" } }
        const html = res?.data?.content || "";
        setContent(html);
      },
      () => {
        message.error("Failed to load Terms & Conditions");
      },
    );
  };

  const saveTerms = () => {
    const body = {
      content,
    };

    callApi(
      "PATCH",
      routes.updateTerms,
      body,
      setSaving,
      () => {
        message.success("Terms & Conditions updated successfully");
        fetchTerms();
      },
      () => {
        message.error("Failed to update Terms & Conditions");
      },
    );
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FFA450" } }}>
      <div className="terms-page-container">
        <Breadcrumb separator=">" className="bread-crumb">
          <div className="icon-dashboard">
            <HomeOutlined className="breadcrumb-icon" />
          </div>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>Terms &amp; Conditions</Breadcrumb.Item>
        </Breadcrumb>

        <Card
          className="terms-card"
          title={
            <span className="terms-title">
              <InfoCircleOutlined className="terms-title-icon" />
              Terms &amp; Conditions
            </span>
          }
          extra={
            <Button
              type="primary"
              onClick={saveTerms}
              loading={saving}
              disabled={loading}
            >
              Save Changes
            </Button>
          }
        >
          {loading ? (
            <div className="terms-loader">
              <Spin />
            </div>
          ) : (
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              className="terms-editor"
            />
          )}
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default TermsConditions;
